<template>
  <div>

 
    <div class="w-full h-10 bg-black lg:fixed lg:inset-y-0">
      
    </div>
    <div class="bg-cover bg-center w-full min-h-screen flex items-center justify-center radial-gradient"  >
      <div class="min-h-full flex flex-col">
        

        <div v-if="visible" class="pt-1 sm:mx-auto sm:w-full sm:max-w-md">
          <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-6 lg:px-6">
  <form class="space-y-6" @submit.prevent="handleSubmit"> 
               <div class="form-group text-center">
  <div class="flex items-center justify-center text-center p-1 text-blue-800">
            <img src="images/logo.png" width="156">
           </div> 
  <h2 class="font-mono text-lg mt-0">
              Ingrese el código generado por su aplicación Google o Microsoft Authenticator
  </h2>
               <div class="d-flex justify-content-center mb-4 mt-4">
  <input
    v-for="(digit, index) in code"
    :key="index"
    ref="inputs"
    v-model="code[index]"
    type="text"
    maxlength="1"
    inputmode="numeric"
    class="form-control text-center mx-1 code-input"
    @input="handleInput(index)"
    @keydown="handleKeydown($event, index)"
    @paste="handlePaste"
  />
</div>

              
              </div>

             <div v-if="loading">
                 <div  class="w-10 h-10 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>  
                </div>
               <button v-else type="submit"  class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 font-mono">
              Verificar
                </button>
  </form>     
        
        </div>

        <div class="flex items-center justify-center text-center  mt-4 text-blue-800"> 
           <span v-if="mail_enviado"> Codigo enviado. Revise su bandeja de entrada</span>
           <a v-else style="cursor:pointer" @click="modalcodigos">¿Problemas para ingresar?  </a> 
       
           <div v-if="loading_mail_enviado">
                 <div  class="w-10 h-10 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>  
           </div>
          </div>
       
       
        </div>
      </div>
    </div>
    <div v-if="isOnline == false" class="sticky bottom-0 bg-red-500 text-white text-center py-4"
      style='z-index:10000000'>
      <p>{{ $t('sinconexion') }}</p>
    </div>
      <div v-if="error == true" class="sticky bottom-0 bg-red-500 text-white text-center py-4"
      style='z-index:10000000'>
      <p>Codigo ingresado no valido</p>
    </div>
  </div>
</template>
<style>
.code-input {
  width: 45px;
  height: 50px;
  font-size: 20px;
  font-weight: bold;
  border-radius: 8px;
}
.code-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.15rem rgba(0,123,255,.25);
}


.radial-gradient {
   
    background: radial-gradient(circle, rgb(171, 217, 255), rgb(210, 214, 246), rgb(122,160,195));
    background-size: 400% 400%;
    animation: gradient 15s ease infinite;
}

@keyframes gradient {
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
}
</style>
<script>
import DOMPurify from "dompurify";
import { mapActions } from "vuex";
 import router from "../../router";
 //import { useParseJwt } from "@/composables/useParseJwt"
 
 import { ref, nextTick } from "vue";
export default {
  name: "OtpSetupQr",


    setup() {
    const code = ref(["", "", "", "", "", ""]);
    const inputs = ref([]);

    const handleInput = (index) => {
      // permitir solo números
      code.value[index] = code.value[index].replace(/\D/g, "");

      // avanzar automáticamente
      if (code.value[index] && index < 5) {
        nextTick(() => {
          inputs.value[index + 1].focus();
        });
      }
    };

    const handleKeydown = (event, index) => {
      // si presiona backspace y está vacío, retrocede
      if (event.key === "Backspace" && !code.value[index] && index > 0) {
        nextTick(() => {
          inputs.value[index - 1].focus();
        });
      }
    };

    const handlePaste = (event) => {
      const pasted = event.clipboardData.getData("text").replace(/\D/g, "");
      if (pasted.length === 6) {
        code.value = pasted.split("");
        nextTick(() => {
          inputs.value[5].focus();
        });
      }
      event.preventDefault();
    };

    return {
      code,
      inputs,
      handleInput,
      handleKeydown,
      handlePaste
    };
  },
  components: {
 
  },
  created() {
    this.checkInternet();
    window.addEventListener("online", this.checkInternet);
    window.addEventListener("offline", () => (this.isOnline = false));
  },
  mounted() {
    
    

     if ( typeof( this.$store.state.auth.tokens)  === "undefined"  || this.$store.state.auth.tokens=='' ) 
     {
      router.push("/");
      console.log("sin definir status login");
      return false;
    } 

    this.error=''
     
  },
  data() {
    return {
      visible:true,
    
      isOnline: false,
      
      loadingTimeout: 30000, // 30 seconds
      
      showModal: false,
      status: "0",
     
      verificado: false,
    
      n1:'',
      n2:'',
      n3:'',
      n4:'',
      n5:'',
      n6:'',
      error:'',
      loading:false,
      mail_enviado:false,
      loading_mail_enviado: false
    
    };
  },
  methods: {
    ...mapActions("auth", ["login"]),
    async handleSubmit(){
        
 

       try {
        
        
        let n1 = DOMPurify.sanitize(this.code[0]);
        let n2 = DOMPurify.sanitize(this.code[1]);
        let n3 = DOMPurify.sanitize(this.code[2]);
        let n4 = DOMPurify.sanitize(this.code[3]);        
        let n5 = DOMPurify.sanitize(this.code[4]);  
        let n6 = DOMPurify.sanitize(this.code[5]);                
        let codigo= `${n1}${n2}${n3}${n4}${n5}${n6}`
     
        this.error=false
        this.loading=true


        const result = await this.$store.dispatch("verify_otp", { codigo  });
        
        
        console.log('status final',result.status)

         
        if (result.status == 200) {
           this.$store.dispatch("leeGoogleDrive");  
          router.push("/home");
        } else {
            this.loading=false;
              this.error = true
              //this.updModal();
              
            }
       
       
      } catch (err) {
        this.error =true
        //this.updModal();
        console.log(err);
        this.mensaje = err;
      }   


    }, 
 
     
    async checkInternet() {
      try {

        await fetch("https://www.google.cl", { mode: "no-cors" });
        this.isOnline = true;
      } catch (error) {
        this.isOnline = false;
      }
    },
  

    async modalcodigos(){
      this.loading_mail_enviado=true
       const result = await this.$store.dispatch("generate_backup_codes" );
       console.log('resp 2',result )
       this.mail_enviado=true
       this.loading_mail_enviado=false
    }
  
  

  
  },
  watch: {
    
  },

}
</script>
